// src/utils/utils_recordingDurationPurchase.ts
// Point d'entrée unique de l'action « Acheter de la durée d'enregistrement ».
//
// La mécanique (choix du palier si plusieurs sont actifs, ajout au panier, ouverture
// directe du paiement) est partagée entre les 5 ressources CreatorCapacity — voir
// utils_creatorCapacityPurchase.ts. Seule cette fonction est à modifier si le point
// d'entrée change — tous les appelants suivront.

import { buyCreatorCapacity }  from "./utils_creatorCapacityPurchase";

export const BUY_RECORDING_DURATION_LABEL = 'Acheter de la durée d\'enregistrement';

/**
 * @param notify  Fonction d'affichage du message. Par défaut window.alert ;
 *                les écrans disposant d'une fenêtre applicative (régie…) passent la leur.
 */
export async function openBuyRecordingDuration(
  notify: (message: string) => void = (message) => window.alert(message)
): Promise<void> {
  return buyCreatorCapacity(
    'recording',
    "L'achat de durée d'enregistrement supplémentaire n'est pas encore disponible.",
    "+ de durée d'enregistrement",
    notify
  );
}
